module.exports = __webpack_public_path__ + "img/tips3.1b38e695.png";